/** For the Hot Seat: answered out loud. Nerves, appearance, tells, and a little probing. */
export const HOT_SEAT_QUESTIONS = [
    { id: "hands", text: "Show us your hands. Are they steady? Why not?" },
    { id: "pulse", text: "Your heart rate right now: higher or lower than when you walked in? Explain." },
    { id: "nervous-habit", text: "What do you do with your hands when you're nervous? Do it now." },
    { id: "eye-contact", text: "Hold eye contact with the person opposite for five seconds. Who looked away first?" },
    { id: "tell", text: "Everyone has a tell when they lie. What's yours? Be honest, we'll check." },
    { id: "blush", text: "Do you go red when you're caught out? Has it happened yet tonight?" },
    { id: "laugh", text: "You laugh when you're nervous. Or do you? Tell us a time it gave you away." },
    { id: "sleep", text: "Will you sleep tonight, knowing what you know? Why?" },
    { id: "first-reaction", text: "When your role appeared, what was the very first thing you felt?" },
    { id: "poker", text: "Describe your role in three words, without giving it away. Go." },
    { id: "outfit", text: "Talk us through tonight's outfit. Was it chosen to look trustworthy?" },
    { id: "look-guilty", text: "Who here looks the most guilty right now, purely on their face?" },
    { id: "dressed-to-deceive", text: "Who in this room dressed to deceive tonight?" },
    { id: "first-impression", text: "Pick someone: what did you think of them the moment you met them?" },
    { id: "trust-face", text: "Whose face would you trust with your life? Whose wouldn't you?" },
    { id: "posture", text: "Sit how you'd sit if you were Unfaithful. Now sit how you'd sit if you were Faithful." },
    { id: "wardrobe", text: "What's the most suspicious thing anyone is wearing tonight?" },
    { id: "glance", text: "Who has glanced at their phone the most since roles came out?" },
    { id: "white-lie", text: "What's the last lie you told, and did you get away with it?" },
    { id: "keep-secret", text: "What's the biggest secret you've kept from someone in this room?" },
    { id: "betray", text: "Would you betray your best friend here for the whole pot? Look at them and answer." },
    { id: "strategy", text: "What's your plan tonight? Give us one real detail." },
    { id: "alliance", text: "Name the one person you'd want on your side. Why them?" },
    { id: "never-trust", text: "Name one person you'd never trust with a secret. Explain yourself." },
    { id: "caught", text: "When were you last caught out in a lie, and how?" },
    { id: "cheat", text: "Do you cheat at board games? Who here would say you do?" },
    { id: "lie-detector", text: "Tell us two things about your day: one true, one false. Room, which is the lie?" },
    { id: "good-liar", text: "On a scale of one to ten, how good a liar are you? Prove the number." },
    { id: "murder-first", text: "If you were Unfaithful, who would you murder first, and why them?" },
    { id: "defend", text: "Someone here will accuse you tonight. Who do you think it'll be?" },
    { id: "traitors-fan", text: "Who's your favourite Traitor from the show, and what did they do well?" },
    { id: "underestimate", text: "Why would it be a mistake to underestimate you?" },
    { id: "promise", text: "Make the room one promise. We'll hold you to it." },
    { id: "proudest-lie", text: "What's a lie you're secretly proud of?" },
    { id: "who-wins", text: "Who do you think will win, and why isn't it you?" },
    { id: "spot-liar", text: "How do you spot a liar? Share your trick, then use it on someone here." },
    { id: "job", text: "What do you really do for a living? Convince us you're not making it up." },
    { id: "talent", text: "What's a talent nobody here knows you have? Is it useful for lying?" },
    { id: "sabotage", text: "If you wanted to sabotage a mission without being caught, how would you do it?" },
    { id: "silence", text: "Stay silent for ten seconds while everyone stares at you. Who cracked a smile?" },
];
/** For Most Likely To: everyone names someone. */
export const MOST_LIKELY_QUESTIONS = [
    { id: "lie-mum", text: "Who is most likely to lie to their own mother?" },
    { id: "first-out", text: "Who will be banished first?" },
    { id: "unfaithful", text: "Who here is most likely Unfaithful?" },
    { id: "most-nervous", text: "Who looks the most nervous right now?" },
    { id: "cry", text: "Who is most likely to cry at the Round Table?" },
    { id: "win", text: "Who is most likely to win the whole thing?" },
    { id: "poker-face", text: "Who has the best poker face in the room?" },
    { id: "panic", text: "Who will crack first under pressure?" },
    { id: "shield", text: "Who is most likely to grab a Shield and say nothing?" },
    { id: "accuse-wrong", text: "Who will accuse the wrong person, loudly?" },
    { id: "talk-way-out", text: "Who could talk their way out of anything?" },
    { id: "secret-plan", text: "Who already has a secret plan?" },
    { id: "trust-first", text: "Who would you trust first?" },
    { id: "flip-vote", text: "Who will change their vote at the last second?" },
    { id: "murdered-first", text: "Who is most likely to be murdered first?" },
    { id: "dressed-to-kill", text: "Who dressed to kill tonight?" },
    { id: "too-calm", text: "Who is suspiciously calm?" },
    { id: "overthink", text: "Who is overthinking everything already?" },
    { id: "steal-pot", text: "Who would run off with the pot?" },
    { id: "sweating", text: "Who is sweating the most right now?" },
    { id: "best-liar", text: "Who is the best liar in this room?" },
    { id: "worst-liar", text: "Who is the worst liar in this room?" },
    { id: "teacher-pet", text: "Who will try hardest to be the Keeper's favourite?" },
];
/** Seconds for each part. Scaled by the game's pace. */
export const GATHERING_TIMING = { hotSeatSec: 30, likelyAskSec: 22, likelyRevealSec: 9, likelyRounds: 3, introSec: 8 };
/** How long Welcome Drinks lasts for this plan, in ms at the given pace factor. */
export function gatheringMs(plan, paceFactor) {
    const t = GATHERING_TIMING;
    return Math.round((t.introSec + plan.hot.length * t.hotSeatSec + plan.likely.length * (t.likelyAskSec + t.likelyRevealSec)) * 1000 * paceFactor);
}
/** What's happening at `now`, given when the drinks began. */
export function gatheringAt(plan, startedAt, paceFactor, now) {
    const t = GATHERING_TIMING;
    const s = (sec) => sec * 1000 * paceFactor;
    let at = startedAt + s(t.introSec);
    if (now < at)
        return { part: "intro", endsAt: at };
    for (let i = 0; i < plan.hot.length; i++) {
        const end = at + s(t.hotSeatSec);
        if (now < end)
            return { part: "hot", index: i, playerId: plan.hot[i].playerId, questionId: plan.hot[i].questionId, endsAt: end };
        at = end;
    }
    for (let i = 0; i < plan.likely.length; i++) {
        const askEnd = at + s(t.likelyAskSec);
        if (now < askEnd)
            return { part: "likely", index: i, questionId: plan.likely[i], stage: "ask", endsAt: askEnd };
        const revealEnd = askEnd + s(t.likelyRevealSec);
        if (now < revealEnd)
            return { part: "likely", index: i, questionId: plan.likely[i], stage: "reveal", endsAt: revealEnd };
        at = revealEnd;
    }
    return { part: "done", endsAt: at };
}
export const HOT_SEAT_BY_ID = Object.fromEntries(HOT_SEAT_QUESTIONS.map((q) => [q.id, q]));
export const MOST_LIKELY_BY_ID = Object.fromEntries(MOST_LIKELY_QUESTIONS.map((q) => [q.id, q]));
//# sourceMappingURL=gathering.js.map